import { useTranslation } from "react-i18next";
import { getDatalakeImageUrl } from "../../../Helpers/DateLakeStorage";
import { useEffect, useState } from "react";

// TODO: Support translation for this component
function FailedToLoadError({ error }) {

    const { t } = useTranslation("common/failed_to_load_error", { useSuspense: false });
    const [message, setMessage] = useState(t("failed_to_load_error"));

    useEffect(() => {
        if (error) {
            if (typeof error === 'string') {
                setMessage(error)
            } else {
                setMessage(error.message);
            }
        }
    }, [])

    return (
        <div className='d-flex flex-column justify-content-center align-items-center h-100'>
            <img src={getDatalakeImageUrl('OverflowError.png')} height={"30%"} />
            <h3>
                { message }
            </h3>
        </div>
    )
}

export default FailedToLoadError;